<template>
 
  <widget-container
    :url="url"
    headlineclass
    cardclass="ma-0 pa-1"
    color="transparent"
    :bus="bus"
    :dark="false"
    :flat="true"
    :alwaysrender="true"
    @ready="setData"
  >
    <template slot="content">
      <div>
        <v-col align="center" v-if="data">
          <div>{{ data.ca | currency("EUR") }}</div>
          <div class="body-1">
            HA {{ data.ha | currency("EUR") }} | Marge =
            {{ data.markup | decimal({ maximumFractionDigits: 2 }) }} %
          </div>
        </v-col>

        <v-col v-else> - </v-col>
      </div>
    </template>
  </widget-container>
</template>
<script>
import WidgetContainer from "./WidgetContainer";
export default {
  name: "WidgetNetworkCa",
  components: { WidgetContainer },
  props: {
    bus: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: false,
      default: "/api/widget/networkca-resume",
    },
  },
  data() {
    return {
      search: null,
      data: null,
    };
  },
  created() {},
  destroyed() {
    this.bus.$off("search");
  },
  methods: {
    setData(data) {
      this.data = data;
    },
  },
};
</script>